import styled from '@emotion/styled';
import {
  Button,
  EmptyState,
  SvgEmptyStateRestrictedContentMedium,
  SvgEmptyStateSystemErrorMedium,
} from '@galaxy-react/core';
import { useTitle } from 'ahooks';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from './Typography';
const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  background: '#fff',
  height: 'calc(100vh - 48px)',
  flex: 1,
});

type IProps = {
  showButton?: boolean;
  type?: 'Unauthorised' | 'Error' | 'NotFound';
};

const TypeMap = {
  Unauthorised: {
    illustration: <SvgEmptyStateRestrictedContentMedium />,
    title: 'This content is restricted',
    description:
      'This content is restricted and unable to be viewed.\nPlease contact your LEAP administrator or go Home.',
  },
  Error: {
    illustration: <SvgEmptyStateSystemErrorMedium />,
    title: 'We’ve encountered an error',
    description: 'Our system has encountered an error. \nPlease click to return home',
  },
  NotFound: {
    illustration: <SvgEmptyStateSystemErrorMedium />,
    title: 'Page not found',
    description: 'Please check your link or go Home.',
  },
};
export default function ErrorPage({ showButton = true, type = 'NotFound' }: IProps) {
  useTitle('LEAP Reports');
  // @ts-ignore
  const navigate = useNavigate();

  const { title, description, illustration } = useMemo(() => {
    const TypeMap = {
      Unauthorised: {
        illustration: (
          <SvgEmptyStateRestrictedContentMedium style={{ cursor: 'pointer' }} onClick={() => navigate('/')} />
        ),
        title: 'This content is restricted',
        description:
          'This content is restricted and unable to be viewed.\nPlease contact your LEAP administrator or return home.',
      },
      Error: {
        illustration: <SvgEmptyStateSystemErrorMedium style={{ cursor: 'pointer' }} onClick={() => navigate('/')} />,
        title: 'We’ve encountered an error',
        description: 'Our system has encountered an error. \nPlease click to return home',
      },
      NotFound: {
        illustration: <SvgEmptyStateSystemErrorMedium style={{ cursor: 'pointer' }} onClick={() => navigate('/')} />,
        title: 'Page not found',
        description: 'Please check your link or return home.',
      },
    };
    return TypeMap[type];
  }, [navigate, type]);
  return (
    <Wrapper>
      <EmptyState
        illustration={illustration}
        headline={title}
        description={
          <>
            <Typography style={{ textAlign: 'center' }}>{description}</Typography>
            {showButton && (
              <Button appearance="primary" onClick={() => navigate('/')} style={{ marginTop: 24 }}>
                Home
              </Button>
            )}
          </>
        }
      ></EmptyState>
    </Wrapper>
  );

  // return <Navigate to=".." relative="route" replace={true}></Navigate>;
}
